// Shared display formatters.
//
// These were previously redefined in ReportsPage, ReceiptsTab and BillingPage, which let the
// screen and its export drift apart (e.g. a KPI rounded on screen but exported raw). Everything
// that renders a number the user might later export should import from here.

const IST = 'Asia/Kolkata';

/** Currency for the SCREEN — real ₹ glyph. Never use this for PDF cells (see moneyPdf). */
export const fmtINR = (v) => new Intl.NumberFormat('en-IN', {
  style: 'currency', currency: 'INR', maximumFractionDigits: 0,
}).format(v ?? 0);

/**
 * Currency for PDF cells. jsPDF's built-in helvetica has no ₹ glyph — it renders as a blank box —
 * so PDFs use an ASCII "INR" prefix instead. Matches the money() helper the bespoke PDF builders
 * in exporters.js already use, so all PDFs read consistently.
 */
export const moneyPdf = (v) => `INR ${Math.round(v ?? 0).toLocaleString('en-IN')}`;

/** Plain grouped number, no currency symbol — for Excel cells that should stay numeric-ish. */
export const num = (v) => (v ?? 0).toLocaleString('en-IN');

/** Fraction (0..1) as a whole percent. */
export const pct = (r) => `${Math.round((r ?? 0) * 100)}%`;

/** Fraction (0..1) as a percent with one decimal — for rates where whole percents hide movement. */
export const pct1 = (r) => `${(((r ?? 0) * 100)).toFixed(1)}%`;

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString('en-IN', { timeZone: IST }) : '—');

export const fmtDateTime = (d) => (d
  ? new Date(d).toLocaleString('en-IN', { timeZone: IST, dateStyle: 'short', timeStyle: 'short' })
  : '—');

/** Short axis label, e.g. "05 Jul". */
export const dayLabel = (d) => new Date(d).toLocaleDateString('en-IN', {
  timeZone: IST, day: '2-digit', month: 'short',
});

/** "1 Jul 2026 – 31 Jul 2026", used as the PDF subtitle on every report export. */
export function rangeLabel(from, to) {
  if (!from && !to) return 'All time';
  const f = from ? fmtDate(from) : '…';
  const t = to ? fmtDate(to) : '…';
  return `${f} – ${t}`;
}
